import React from "react"
import { DropdownIconNames } from "./dropdownIconNames"
import ValuationTablesIcon from "./table.svg?react"
import ManageUsersIcon from "./users.svg?react"
import AdminIcon from "./admin.svg?react"
import EditPricingRulesIcon from "./edit.svg?react"
import LogOutIcon from "./logout.svg?react"

interface IconProps {
  name: DropdownIconNames
  height?: string
  fill?: string
}

const Icon = ({ name, fill, height }: IconProps) => {
  let PickedIcon
  console.log(name)
  switch (name) {
    case DropdownIconNames.VALUATION_TABLE:
      PickedIcon = ValuationTablesIcon
      break
    case DropdownIconNames.MANAGE_USERS:
      PickedIcon = ManageUsersIcon
      break
    case DropdownIconNames.ADMIN:
      PickedIcon = AdminIcon
      break
    case DropdownIconNames.EDIT_PRICING_RULES:
      PickedIcon = EditPricingRulesIcon
      break
    case DropdownIconNames.LOG_OUT:
      PickedIcon = LogOutIcon
      break
  }
  return <PickedIcon height={height} fill={fill} />
}

export default Icon
